
export const html = (content) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  return doc.body.firstChild;
};



// WEBPACK FOOTER //
// ./themes/app/assets/js/utils.js